import { fetch } from '../fetchWrapper/fetch';
import { API_URL, Status } from '../constants';

export enum NotificationStatus {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  PENDING_REVIEW = 'PENDING_REVIEW',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  PARTIAL_SUCCESS = 'PARTIAL_SUCCESS',
  CANCELLED = 'CANCELLED',
  SENT = 'SENT',
  SCHEDULED = 'SCHEDULED',
}

export enum NotificationType {
  PDF = 'PDF',
  PRICE_SCHEME_IMPORT = 'PRICE_SCHEME_IMPORT',
  PRICE_SCHEME_EXPORT = 'PRICE_SCHEME_EXPORT',
  PRICE_SCHEME_DUPLICATE = 'PRICE_SCHEME_DUPLICATE',
  PRODUCT_SYNC = 'PRODUCT_SYNC',
  VENUE_SYNC = 'VENUE_SYNC',
  PRODUCT_PUBLISH = 'PRODUCT_PUBLISH',
  MENU_PUBLISH = 'MENU_PUBLISH',
  ALLERGEN_VALIDATION = 'ALLERGEN_VALIDATION',
  VALIDATION = 'VALIDATION',
  PUBLISH_RESULT = 'PUBLISH_RESULT',
}

export interface INotification {
  type: NotificationType;
  assets: string[] | null;
  status: NotificationStatus;
  message: string | null;
  event_id: string;
  create_date: string;
  dismissible: boolean;
  endpoint_name: string | null;
  notification_id: string;
  external_system_name: string | null;
  schedule_id: string | null;
  report_id: string | null;
  name?: string | null;
}

export const getNotifications = async (): Promise<INotification[]> => {
  const res = await fetch(`${API_URL}/notifications`);
  if (res.status !== Status.SUCCESS) {
    throw new Error();
  }
  const { data }: { data: INotification[] } = await res.json();
  return data;
};
